import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./Redux/store";
import { BasicContextProvider } from "./context/BasicContext";
import { AudioProvider } from "./context/AudioProvider";
import { BookProvider } from "./context/DownloadBookProvider";
import { DownloadMusicProvider } from "./context/DownloadAudioProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BasicContextProvider>
      <AudioProvider>
        <BookProvider>
          <DownloadMusicProvider>
            <App />
          </DownloadMusicProvider>
        </BookProvider>
      </AudioProvider>
    </BasicContextProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
